import { render, staticRenderFns } from "./Lightup.vue?vue&type=template&id=0d88f640&"
import script from "./Lightup.vue?vue&type=script&lang=js&"
export * from "./Lightup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports